/** @format */

import React from "react";

type navBarLinksProps = {
  link: string;
  title: string;
  onClick?: React.MouseEventHandler;
};

const NavBarLinks = ({ link, title, onClick }: navBarLinksProps) => {
  return (
    <a href={link} onClick={onClick}>
      <h3 className="opacity-100 cursor-pointer">{title}</h3>
    </a>
  );
};

export default NavBarLinks;
